var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52994 5.93469L7.94894 0.534689C7.97449 0.493017 7.99069 0.446299 7.99644 0.397757C8.00218 0.349216 7.99733 0.300005 7.98221 0.25352C7.9671 0.207036 7.94208 0.164383 7.90889 0.128502C7.87569 0.0926218 7.83511 0.0643683 7.78994 0.0456891C7.72757 0.0156708 7.65916 0.000279933 7.58994 0.000689065L0.409942 0.000689693C0.307909 -0.00562171 0.207525 0.0286944 0.130707 0.0961439C0.0538888 0.163594 0.00687882 0.258698 -5.82009e-05 0.360689C0.000168779 0.428029 0.0211167 0.493668 0.0599413 0.54869L3.82094 5.94869C3.88538 6.03214 3.9774 6.08994 4.08055 6.11174C4.18371 6.13354 4.29125 6.11793 4.38394 6.06769C4.44332 6.03677 4.49363 5.99093 4.52994 5.93469Z",
    fill: "#C5C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort-arrow.640223bf248ddef6e96a849b63a6e918.svg";
export { ForwardRef as ReactComponent };